import { AboutUsPageTranslationsCs } from 'pages/AboutUsPage/translations/cs';
import { NotFoundPageTranslationsCs } from 'pages/NotFoundPage/translations/cs';
import { UserPageTranslationsCs } from 'pages/UserPage/translations/cs';

export const PagesTranslationsCs = {
  notFoundPage: NotFoundPageTranslationsCs,
  aboutUsPage: AboutUsPageTranslationsCs,

  userPage: UserPageTranslationsCs, // =>

};
